import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { X, GitCompare, Trash2 } from "lucide-react";
import { useCompare } from "../context/CompareContext";
import { useLang } from "../i18n";
import { store } from "../lib/storage";
import ProductImage from "./ProductImage";

export default function CompareBar() {
  const { items, remove, clear } = useCompare();
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  if (!items.length) return null;
  if (location.pathname === "/comparateur") return null;

  const cookiePending = !store.get("smarti_cookie_consent");

  return (
    <div className={`fixed inset-x-0 bottom-0 z-[80] px-3 pb-3 lg:px-5 lg:pb-5 ${cookiePending ? "pb-[132px] sm:pb-[120px]" : ""}`} data-testid="compare-bar">
      <div className="mx-auto flex max-w-4xl flex-col gap-3 rounded-[24px] border border-white/60 bg-white/80 p-3 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.25)] backdrop-blur-2xl sm:flex-row sm:items-center sm:gap-4 sm:pl-4">
        <div className="flex items-center gap-2 text-[13px] font-semibold text-[#0A0A0F]">
          <GitCompare className="h-4 w-4 text-[#0073FF]" />
          <span>{items.length} {t("modèle(s) sélectionné(s)")}</span>
        </div>
        <div className="flex flex-1 items-center gap-2 overflow-x-auto">
          {items.map((it) => (
            <div key={it.slug} className="group relative flex shrink-0 items-center gap-2 rounded-2xl bg-black/[0.04] py-1.5 pl-2 pr-3" data-testid={`compare-chip-${it.slug}`}>
              <div className="h-8 w-8 overflow-hidden rounded-lg bg-white">
                <ProductImage src={it.image} alt={it.name} label={it.name} className="h-full w-full object-contain" />
              </div>
              <span className="max-w-[120px] truncate text-[12px] font-medium text-[#0A0A0F]">{it.name}</span>
              <button onClick={() => remove(it.slug)} className="grid h-5 w-5 place-items-center rounded-full text-[#86868B] hover:bg-black/10 hover:text-[#0A0A0F]" data-testid={`compare-remove-${it.slug}`}>
                <X className="h-3.5 w-3.5" />
              </button>
            </div>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <button onClick={clear} className="grid h-10 w-10 place-items-center rounded-full text-[#86868B] hover:bg-black/5 hover:text-[#0A0A0F]" data-testid="compare-clear" title={t("Vider")}>
            <Trash2 className="h-4 w-4" />
          </button>
          <button
            onClick={() => navigate("/comparateur")}
            className="inline-flex items-center gap-2 rounded-full bg-[#0A0A0F] px-6 py-2.5 text-[13px] font-medium text-white transition-transform hover:-translate-y-0.5"
            data-testid="compare-go"
          >
            <GitCompare className="h-4 w-4" /> {t("Comparer maintenant")}
          </button>
        </div>
      </div>
    </div>
  );
}
